const useQueryParams = () => {
    const setParams = (newPath: string) => {
        window.history.pushState({ path: newPath }, '', `?${newPath}`)
    }

    const setSearchParams = (key: string, value: string) => {
        const urlSearchParams = new URLSearchParams(window.location.search)

        urlSearchParams.set(key, value)

        const updatedSearchParams = urlSearchParams.toString()

        setParams(updatedSearchParams)
    }

    const deleteSearchParam = (key: string) => {
        const urlSearchParams = new URLSearchParams(window.location.search)

        urlSearchParams.delete('modal')

        const updatedSearchParams = urlSearchParams.toString()

        setParams(updatedSearchParams)
    }

    return { setSearchParams, deleteSearchParam }
}

export default useQueryParams
